import Papa from "papaparse";

// Detect the most likely delimiter from a header line (Excel in es-* locales
// often exports with ';'). Falls back to comma.
export function detectDelimiter(headerLine) {
  const candidates = [",", ";", "\t", "|"];
  let best = ",";
  let bestCount = 0;
  for (const d of candidates) {
    const count = headerLine.split(d).length - 1;
    if (count > bestCount) { bestCount = count; best = d; }
  }
  return best;
}

// Robust CSV parse: reads the file as text, strips a UTF-8 BOM, auto-detects the
// delimiter, and parses with headers. Returns the PapaParse result object.
export async function parseCsvFile(file, { transformHeader } = {}) {
  let text = await file.text();
  if (text && text.charCodeAt(0) === 0xfeff) text = text.slice(1); // strip BOM
  const firstLine = (text.split(/\r?\n/)[0] || "");
  const delimiter = detectDelimiter(firstLine);
  return new Promise((resolve, reject) => {
    Papa.parse(text, {
      header: true,
      skipEmptyLines: true,
      delimiter,
      transformHeader,
      complete: resolve,
      error: reject,
    });
  });
}
